class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverTimeout = null;
    
    // Prevent default click behavior on summary
    if (this.summary) {
      this.summary.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    }
    
    // Add hover handlers
    this.setupHoverHandlers();
  }

  setupHoverHandlers() {
    const menuItem = this.closest('li');
    if (!menuItem) return;
    
    // Open menu on hover over the menu item (summary or content)
    menuItem.addEventListener('mouseenter', () => {
      this.clearHoverTimeout();
      this.open();
    });
    
    // Close menu when mouse leaves the menu item
    menuItem.addEventListener('mouseleave', () => {
      this.closeWithDelay();
    });
  }

  open() {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      if (this.summary) {
        this.summary.setAttribute('aria-expanded', 'true');
      }
      this.onToggle();
    }
  }

  closeWithDelay() {
    // Small delay to allow moving mouse from summary to content
    this.clearHoverTimeout();
    this.hoverTimeout = setTimeout(() => {
      this.close();
    }, 100);
  }

  clearHoverTimeout() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
